import React, { useState, useReducer, useContext } from 'react';
import tabsReducer from './reducers/tabs';
import TabsContext from './context/tabs-context';

export function TabsNav({ data }) {
  const { currentTab, tabsDispatch } = useContext(TabsContext);

  const handleTabClick = (event) => {
    const tab = event.target.dataset.toggleSwitch;
    tabsDispatch({ type: 'CURRENT_TAB', tab });
  };

  return (
    <nav className="tabs__nav">
      <ul role="tablist">
        {data.map(({ heading }, index) => (
          <li key={index} role="presentation">
            <button
              role="tab"
              className={`toggle__switch ${
                currentTab === `tab-${index}` ? 'toggle__switch--on' : ''
              }`}
              data-toggle-switch={`tab-${index}`}
              data-toggle-parent="tabs-events"
              onClick={handleTabClick}
            >
              {heading}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export function TabsContent({ data }) {
  const { currentTab } = useContext(TabsContext);

  return (
    <div className="tabs__content">
      {data.length > 0 ? (
        data.map(({ heading, body }, index) => (
          <div
            key={index}
            className={`toggle__target ${
              currentTab === `tab-${index}`
                ? 'toggle__target--visible'
                : 'toggle__target--hidden'
            }`}
            data-toggle-target={`tab-${index}`}
            data-toggle-target-transition="fade"
            role="tabpanel"
          >
            {body}
          </div>
        ))
      ) : (
        <p className="p--sm">No approved events.</p>
      )}
    </div>
  );
}

export default function Tabs({ data, children }) {
  const [currentTab, tabsDispatch] = useReducer(tabsReducer, 'tab-0');

  return (
    <TabsContext.Provider value={{ currentTab, tabsDispatch }}>
      <div
        className="tabs"
        data-toggle-group="tabs-events"
        data-toggle-group-require-active="true"
      >
        {children}
      </div>
    </TabsContext.Provider>
  );
}
